// Routing
import { useHistory } from 'react-router-dom'
// React Error Boundary
import { FallbackProps } from 'react-error-boundary'
// MainStem
import { Button, ButtonGroup, Card, CardBody, theme } from '@mainstem/react-mainstem'
// Icons
import { faChevronLeft, faHome, faRotateRight } from '@fortawesome/pro-light-svg-icons'
// Local - Styled Components
import { SCErrorContent, SCErrorWrapper } from './styles'

/**
 * Detects whether an error was caused by a failed dynamic import (chunk load
 * failure). This typically happens after a new deployment when old JS chunks
 * have been replaced.
 */
function isChunkLoadError(error?: Error): boolean {
  if (!error) return false
  const message = error.message || ''
  return (
    error.name === 'ChunkLoadError' ||
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Loading chunk') ||
    message.includes('Loading CSS chunk') ||
    message.includes('Importing a module script failed')
  )
}

const PageErr: React.FC<FallbackProps> = ({ error }) => {
  const history = useHistory()
  const isDeployError = isChunkLoadError(error)

  const handleRefresh = () => {
    window.location.reload()
  }

  const handleGoBack = () => {
    history.go(-1)
    window.location.reload()
  }

  const handleGoHome = () => {
    history.push('/')
    window.location.reload()
  }

  return (
    <SCErrorWrapper>
      <SCErrorContent>
        <img alt='Sad Panda' src={theme.images.panda.sad} style={{ height: '100px' }} />
        <hr className='mt-0' />
        <Card>
          <CardBody topPadding>
            {isDeployError ? (
              <div className='text-center'>
                <h1>New Update Available!</h1>
                <p>We just deployed an update to Purchase Pro&trade;.</p>
                <p>Please refresh the page to get the latest version.</p>
                <Button block color='primary' icon={faRotateRight} onClick={handleRefresh}>
                  Refresh Now
                </Button>
              </div>
            ) : (
              <>
                <div className='text-center'>
                  <h1>Uh Oh...</h1>
                  <p>It looks like something did not go as expected.</p>
                  <p>Our team has been notified about this error and we will look into it right away!</p>
                </div>
                <ButtonGroup style={{ width: '100%' }}>
                  <Button block color='secondary' icon={faHome} onClick={handleGoHome}>
                    <span>Go Home</span>
                  </Button>
                  <Button block color='primary' icon={faChevronLeft} onClick={handleGoBack}>
                    Go Back
                  </Button>
                </ButtonGroup>
              </>
            )}
          </CardBody>
        </Card>
      </SCErrorContent>
    </SCErrorWrapper>
  )
}

export default PageErr
